<template>
	<div>
		<div id="page-top" class="jumbotron foto1">
			<div class="container">
				<div class="row">
					<div class="col-4 col-sm-4 col-md-3">
						<img class="img-fluid logo-top" src="images/xplorex logo white.jpg" />
					</div>
					<div class="col-7 col-sm-7 col-md-5 offset-md-4">
						<img class="img-fluid planet-top" src="images/planet_logo_shadow.png" />
					</div>
					<!-- <div class="col-sm-6 offset-sm-1 col-xs-8 planet-top">
						<img class="img-fluid" src="images/planet_logo.png">
					</div>-->
				</div>
			</div>
		</div>

		<section>
			<div class="container">
				<div class="row mt-4">
					<div id="whatwedo-title" class="col-md-12" contenteditable="false" v-html="quarkRead('whatwedo-title')"></div>
					<div id="whatwedo-content" class="col-md-12" contenteditable="false" v-html="quarkRead('whatwedo-content')"></div>
				</div>
				<div class="row">
					<div class="col-md-12">
						<h2>Latest video; Brixlegg archeological site</h2>
						<br />
					</div>
					<div class="col-md-6">
						<img class="img-fluid" :src="movie[3].poster" alt="movie1" @click="playMovie(3)" />
						<br />
						<br />
						<p>The planet; the portable high resolution diffractometer from xplorex is used at an archeological site to investigate a Copper mine from the bronze age.</p>
					</div>
					<div class="col-md-4">
						<a href="/pdf/appnote4-Archeology.pdf">
							<img class="img-fluid border" src="/pdf/appnote4-Archeology.jpg" />
						</a>
					</div>
				</div>
				<div class="row my-4">
					<div class="col-md-12">
						<h2>
							<router-link to="/about">Click here for our other videos</router-link>
						</h2>
					</div>
				</div>
			</div>
		</section>

		<!-- Modal Component -->
		<b-modal id="videoModalRef" size="lg" :title="movieTitle" :hide-header="false" :hide-footer="true" @hide="stopMovie">
			<div class="embed-responsive embed-responsive-16by9">
				<iframe :src="played" class="embed-responsive-item"></iframe>
			</div>
		</b-modal>

		<!-- <div class="jumbotron foto2"></div>
		<div class="jumbotron foto3"></div>
		<div class="jumbotron foto4"></div>-->
	</div>
</template>

<script>
import axios from 'axios';

export default {
	data: () => ({
		baseUrl: '/db-sqlite.php',
		images: [],
		movie: [
			// https://www.thewebtaylor.com/articles/how-to-get-a-youtube-videos-thumbnail-image-in-high-quality
			{
				title: 'xplorex Documentary',
				href: 'https://www.youtube.com/embed/1X1SFrOwY4o',
				poster: 'images/video0.jpg'
			},
			{
				title: 'High Resolution XRD Powder Diffraction',
				href: 'https://www.youtube.com/embed/AauFlzmMniA',
				poster: 'images/video1.jpg'
			},
			{
				title: 'The xplorex Team',
				href: 'https://www.youtube.com/embed/YZP33Er376Q',
				poster: 'images/video2.jpg'
			},
			{
				title: 'Brixlegg archeological site',
				href: 'https://www.youtube.com/embed/RN6ndxr8KYI',
				poster: 'images/video3.jpg'
			}
		],
		movieTitle: '',
		played: '',
		index: null,
		content: []
	}),

	created() {
		console.clear();
		this.images = this.movie2;
		axios
			.get(this.baseUrl + '/quark_table')
			.then(response => {
				this.content = response.data;
				for (var i = 0; i < this.content.length; i++) {
					//this.content[i].content = this.content[i].content.split('img-responsive').join('img-fluid');
					// this.content[i].content = this.content[i].content.replace(/<([^ >]+)[^>]*>/ig, '<$1>');
					// this.content[i].content = this.content[i].content.split('<table>').join('<table class="table  table-bordered">');
				}
				//console.log(this.content[0].content);
			})
			.catch(e => {
				// this.errors.push(e)
				console.log(e);
			});
	},

	methods: {
		quarkRead(section) {
			var content;
			for (var i = 0; i < this.content.length; i++) {
				if (this.content[i].section == section) {
					content = this.content[i].content;
					break;
				}
			}

			return content;
		},

		playMovie(movieNr) {
			this.played = this.movie[movieNr].href;
			this.movieTitle = this.movie[movieNr].title;
			this.$bvModal.show('videoModalRef');
		},

		stopMovie() {
			// stop movie by setting the iframe's src attribute
			this.played = '';
		}
	}
};
</script>

<style scoped>
.logo-top {
	margin-top: 20px;
	width: 170px;
	/* max-width: 170px; */
	z-index: 10;
}

.planet-top {
	/* margin-top: 230px; */
	margin-top: 20px;
	width: 350px;
	/* max-width: 350px; */
	z-index: 10;
}

.foto1 {
	display: block;
	overflow: auto;
	background-image: url(/images/foto1_crop.jpg);
	background-repeat: no-repeat;
	background-position-x: center;
}

.foto2 {
	height: 370px;
	background-image: url(/images/foto2.jpg);
	background-repeat: no-repeat;
	background-position-x: center;
}

.foto3 {
	height: 370px;
	background-image: url(/images/foto3.jpg);
	background-repeat: no-repeat;
}

.foto4 {
	height: 370px;
	background-image: url(/images/foto4.jpg);
	background-repeat: no-repeat;
	background-position-x: center;
}

.altWrap {
	border-top: 1px solid #eee;
	border-bottom: 1px solid #eee;
	background-color: #f7f7f7;
}
</style>
